export const initialCustomerService = {
    serviceName: "",
    description: "",
    inputFields: [],
    selectFields: [],
    price: null,
    parentService: null,
  };